import { render, staticRenderFns } from "./ExpeditionButton.vue?vue&type=template&id=1f708bfb&scoped=true"
import script from "./ExpeditionButton.vue?vue&type=script&lang=js"
export * from "./ExpeditionButton.vue?vue&type=script&lang=js"
import style0 from "./ExpeditionButton.vue?vue&type=style&index=0&id=1f708bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f708bfb",
  null
  
)

export default component.exports